import React from 'react';
import { useState, useEffect, useMemo } from 'react';

import ModelType from '../../Model/ModelType';
import { hasValidInput } from 'components/Model/ModelUtils';
import EditItemModal from '../../Modals/EditItemModal';
import { useTranslation } from '../../../localization/useTranslation';
import _ from 'lodash';

const defaultOrganization = {
  displayName: '',
  description: ''
};


const NewOrganizationDialog = ({ isOpen, onSave, onCancel, parentOrgs }) => {
  const [organization, setOrganization] = useState({ ...defaultOrganization });
  const T = useTranslation();

  const model = useMemo(() => {
    return [
      {
        type: ModelType.OPTIONSV2,
        label: 'Parent',
        path: 'parent',
        options: _.map(parentOrgs, value => ({ value, text: value.displayName })),
        isRequired: true,
        hasError: _.isEmpty,
        properties: {
          isTypeahead: true
        }
      },
      {
        type: ModelType.TEXT,
        label: 'Display Name',
        path: 'displayName',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXTAREA,
        label: 'Description',
        path: 'description'
      }
    ];
  }, [parentOrgs]);


  useEffect(() => {
    setOrganization({
      ...defaultOrganization
    });
  }, []);

  useEffect(function updateOrgData() {
    setOrganization(oldOrg => {
      if (!oldOrg?.parent?.id) {
        return { ...oldOrg, parentOrganizationId: null, privileges: [] };
      }
      return ({ ...oldOrg, parentOrganizationId: oldOrg?.parent.id, privileges: [] });
    });
  }, [organization?.parent]);


  const _onSave = (org) => {
    setOrganization(defaultOrganization);
    onSave(org);
  };

  const _onCancel = () => {
    setOrganization(defaultOrganization);
    onCancel();
  };

  return (
    <>
      <EditItemModal
        isOpen={isOpen}
        // isLoading={isCreating}
        // TODO: translate
        title={T.organization.create.title}
        saveEnabled={hasValidInput(organization, model)}
        onSave={_onSave}
        onCancel={_onCancel}
        item={organization}
        setItem={setOrganization}
        models={model}
      />
    </>
  );
};

export default NewOrganizationDialog;
